export class CropAnalysis {
  phenologicalStage?: string;
  emergencies?: string;
  cropGrowth?: string;
  soil?: string;
  deficient?: string;

  constructor() {
    this.phenologicalStage = null;
    this.emergencies = null;
    this.cropGrowth = null;
    this.soil = null;
    this.deficient = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

class CropAnalysis {
  string phenologicalStage
  string emergencies
  string cropGrowth
  string soil
  string deficient

  static mapping = {
    autoTimestamp true
  }

  static constraints = {
    phenologicalStage   blank: false, nullable: true
    emergencies         blank: false, nullable: true, inList: ["regular", "uneven"]
    cropGrowth          blank: false, nullable: true, inList: ["irregular", "slightIrregularities", "homogeneous", "lush", "stunted"]
    soil                blank: false, nullable: true, inList: ["fine", "coarse", "inTempera", "split"]
    deficient           blank: false, nullable: true, inList: ["N", "P", "k", "Mn", "Zn", "Fe", "S", "Other"]
  }
}
*/
